import { useState, useEffect, useRef } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Constant from '@/common/constant/Constant';
import LoadingPanel from '../common/LoadingPanel';
import FieldList from './FieldList';
import FormListDev from './FormListDev';
import './FormListUI.css';
import './FormManagement.css';
import { getListAllCorporation } from '@/service/organizationService';
import {
    getActiveB2BCustomerListInProjectByProjectId,
    getActiveB2BHelpdeskProject
} from '@/service/projectService';
import Utils from '@/common/utils/utils';
import { useRecoilState, useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { formPanelTabCloseManagementAtom } from '@/state/atom/formAtom'
import _ from 'lodash';
import { PropTypes } from 'prop-types';

FormManagement.propTypes = {
    API: PropTypes.any,
    tabId: PropTypes.any,
    panelId: PropTypes.any,
    // triggerReload: PropTypes.any
};

export default function FormManagement(props) {
    const [tabSelected, setTabSelected] = useState(Constant.TAB_FORM_MANAGEMENT.FORM);
    const [isLoading, setIsLoading] = useState(false);
    const [formPanelTabClose, setFormPanelTabClose] = useRecoilState(formPanelTabCloseManagementAtom);
    const [isOpenUnsavedChangesDialog, setIsOpenUnsavedChangesDialog] = useState(false);

    const onChangeTabSelected = tabType => {
        if (tabSelected === tabType) return;
        if (formPanelTabClose.isDirty) {
            setIsOpenUnsavedChangesDialog(true);
            return;
        }
        setTabSelected(tabType);
    };

    useEffect(() => {
        if (formPanelTabClose.isDirty && formPanelTabClose.isClosePanel) {
            setIsOpenUnsavedChangesDialog(true);
        }
    }, [formPanelTabClose]);

    // uef listen when after changeTab, auto reset formPanelTabClose
    useEffect(() => {
        setFormPanelTabClose({
            isDirty: false,
            isClosePanel: false,
            isCloseScreen: false
        });
    }, [tabSelected]);

    const projectDetail = useRecoilValue(projectInuseDetailAtom);

    const [allListCorp, setAllListCorp] = useState([]);
    const [b2bCustomerList, setB2BCustomerList] = useState([]);
    const [b2bHelpDeskList, setB2BHelpDeskList] = useState([]);

    const fetchCorpPrjRef = useRef(null);

    useEffect(() => {
        fetchCorpPrjRef.current = true;

        const fetchData = async () => {
            try {
                const [allCorps, customerList, helpdeskList] = await Promise.all([
                    getListAllCorporation(props?.API),
                    getActiveB2BCustomerListInProjectByProjectId(props?.API, projectDetail.id),
                    getActiveB2BHelpdeskProject(props?.API, projectDetail.id),
                ]);

                if (!fetchCorpPrjRef.current) return;

                const activeCorpList = allCorps.filter(corp => corp?.active === Constant.CORPORATION_ACTIVE.ACTIVE);
                setAllListCorp(_.sortBy(activeCorpList.map(corpDetail => ({
                    id: corpDetail.id,
                    title: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corpDetail.name),
                    subDomain: corpDetail.organizationDomain,
                    active: corpDetail.active,
                    contractType: corpDetail.contractType
                })), ['title']));

                setB2BCustomerList(_.sortBy(_.uniqBy(customerList.map(corpDetail => ({
                    id: corpDetail.orgId,
                    title: corpDetail.orgName,
                    subDomain: corpDetail.organizationDomain,
                    active: corpDetail.orgActive,
                    contractType: corpDetail.contractType
                })), 'id'), ['title']));

                setB2BHelpDeskList(_.sortBy(_.uniqBy(helpdeskList.map(corpDetail => ({
                    id: corpDetail.orgId,
                    title: corpDetail.orgName,
                    subDomain: corpDetail.organizationDomain,
                    active: corpDetail.orgActive,
                    contractType: corpDetail.contractType
                })), 'id'), ['title']));
            } catch (error) {
                console.error('Error loading corporation lists:', error);
            }
        };

        fetchData();

        return () => {
            fetchCorpPrjRef.current = false;
        };
    }, []);

    /** render tab header */
    const renderTabHeader = () => {
        return (
            <div className="navTabs">
                <AppBar className="navTabs-box" position="static">
                    <Tabs
                        className="navTabs-rot"
                        value={tabSelected}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        {/* form */}
                        <Tab
                            data-cy="tab-form-mangement"
                            className="navTabs--item"
                            label="フォーマット編集"
                            value={Constant.TAB_FORM_MANAGEMENT.FORM}
                            onClick={() => onChangeTabSelected(Constant.TAB_FORM_MANAGEMENT.FORM)}
                        />
                        {/* field */}
                        <Tab
                            data-cy="tab-field-mangement"
                            className="navTabs--item"
                            label="フィールド編集"
                            value={Constant.TAB_FORM_MANAGEMENT.FIELD}
                            onClick={() => onChangeTabSelected(Constant.TAB_FORM_MANAGEMENT.FIELD)}
                        />
                    </Tabs>
                </AppBar>
            </div>
        );
    };
    return (
        <div className="form-management">
            <LoadingPanel isLoading={isLoading} />

            {/* tab header */}
            <div className="mainTop">{renderTabHeader()}</div>

            {/* form list */}
            {Constant.TAB_FORM_MANAGEMENT.FORM === tabSelected && (
                <FormListDev
                    API={props?.API}
                    setIsLoading={setIsLoading}
                    tabId={props?.tabId}
                    panelId={props?.panelId}
                    allListCorp={allListCorp}
                    b2bCustomerList={b2bCustomerList}
                    b2bHelpDeskList={b2bHelpDeskList}
                    triggerReload={props?.triggerReload}
                    isOpenUnsavedChangesDialog={isOpenUnsavedChangesDialog}
                    setIsOpenUnsavedChangesDialog={setIsOpenUnsavedChangesDialog}
                    tabSelected={tabSelected}
                    setTabSelected={setTabSelected}
                />
            )}

            {/* field list */}
            {Constant.TAB_FORM_MANAGEMENT.FIELD === tabSelected && (
                <FieldList
                    API={props?.API}
                    setIsLoading={setIsLoading}
                    tabId={props?.tabId}
                    panelId={props?.panelId}
                    allListCorp={allListCorp}
                    b2bCustomerList={b2bCustomerList}
                    b2bHelpDeskList={b2bHelpDeskList}
                    triggerReload={props?.triggerReload}
                    isOpenUnsavedChangesDialog={isOpenUnsavedChangesDialog}
                    setIsOpenUnsavedChangesDialog={setIsOpenUnsavedChangesDialog}
                    tabSelected={tabSelected}
                    setTabSelected={setTabSelected}
                />
            )}
        </div>
    );
}
